/** Maps API report rows to Excel/PDF fields used by the on-screen table. */

const emptyToBlank = (value) => (value === undefined || value === null ? "" : value);

export function mapRowsForExcel({ reportType, type, interval, rows = [] }) {
  if (!Array.isArray(rows)) {
    return [];
  }

  if (type === "do_sensor") {
    return rows.map((data) => ({
      dateTime: emptyToBlank(data.date_time),
      dissolvedOxygenMgL: emptyToBlank(data.dissolved_oxygen),
      temperatureC: emptyToBlank(data.temp),
    }));
  }

  if (reportType === "Flow Report") {
    if (type === "flow") {
      if (interval === "") {
        return rows.map((data) => ({
          dateTime: emptyToBlank(data.date_time),
          flowrate: data.flowrate,
          totalizer: data.totalizer,
          cumulativeTotalizer: data.change_totalizer,
        }));
      }
      return rows.map((data) => ({
        dateTime: emptyToBlank(data.date_column),
        flowrate: data.avg_flowrate,
        totalizer: data.max_totalizer,
        cumulativeTotalizer: data.change_max_totalizer,
      }));
    }

    if (interval === "") {
      return rows.map((data) => ({
        dateTime: emptyToBlank(data.date_time),
        level: data.level,
        changeInLevel: data.change_level,
      }));
    }

    return rows.map((data) => ({
      dateTime: emptyToBlank(data.date_column || data.date),
      maxLevel: data.max_level,
      changeInMaxLevel: data.change_max_level,
    }));
  }

  if (reportType === "Battery Report") {
    return rows.map((data) => ({
      startTime: data.start,
      endTime: data.end,
      battery: "ON",
    }));
  }

  return rows.map((data) => ({
    startTime: data.start_time,
    endTime: data.end_time,
    time: Math.round(
      (new Date(data.end_time) - new Date(data.start_time)) / (1000 * 60 * 60)
    ),
    cumulativeTime: Math.round(
      (new Date(data.end_time) - new Date(data.start_time)) / (1000 * 60 * 60)
    ),
  }));
}

export function getPdfTableHead({ reportType, type, interval }) {
  if (type === "do_sensor") {
    return ["Index", "Date / Time", "Dissolved oxygen (mg/L)", "Temperature (C)"];
  }
  if (reportType === "Flow Report") {
    if (type === "level") {
      return interval === ""
        ? ["Index", "Date / Time", "Level", "Change in Level"]
        : ["Index", "Date / Time", "Max Level", "Change in Max Level"];
    }
    return [
      "Index",
      "Date / Time",
      "Flow",
      "Totalizer",
      "Cumulative Totalizer",
    ];
  }

  if (reportType === "Battery Report") {
    return ["Index", "Start Date/Time", "End Date/Time", "Battery"];
  }

  return ["Index", "Interval", "Time", "Cumulative Time"];
}

export function getLevelPdfRowValues(item = {}, interval) {
  if (interval === "") {
    return {
      dateTime: emptyToBlank(item.date_time),
      value: emptyToBlank(item.level),
      change: emptyToBlank(item.change_level),
    };
  }

  return {
    dateTime: emptyToBlank(item.date_column || item.date),
    value: emptyToBlank(item.max_level),
    change: emptyToBlank(item.change_max_level),
  };
}
